import React from "react";
import { useQueryRules } from "react-instantsearch";

const CustomDataBanner = (props) => {
  const { items } = useQueryRules(props);

  if(!items || items.length === 0) {
    return <></>;
  }

  const messages = items.filter(item => item.message && item.message.trim() !== '');
  if(messages.length === 0) {
    return <></>;
  }

  return (
    <>
      <div className="algolia-search-custom-data-banners">
        {messages.map(({ message, link, linkText }) => (
          <div
            className="algolia-search-custom-data-banners__item"
            key={message}
          >
            <span className="algolia-search-custom-data-banner__items__message">
              {message}
            </span>
            {link && linkText && (
              <a
                className="algolia-search-custom-data-banner__items__link"
                href={link}
              >
                {linkText}
              </a>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default CustomDataBanner;
